import { forwardRef, type ButtonHTMLAttributes } from "react";
import { cx } from "@/shared/lib/cx";

export type ButtonVariant = "primary" | "secondary" | "ghost" | "outline" | "error";
export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

const variantClass: Record<ButtonVariant, string> = {
  primary: "btn-primary",
  secondary: "btn-secondary",
  ghost: "btn-ghost",
  outline: "btn-outline btn-primary",
  error: "btn-error",
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant, className, type = "button", ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cx("btn btn-sm shadow-none", variant && variantClass[variant], className)}
      {...props}
    />
  );
});
